/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CreateNewFlowIcon = createIcon("CreateNewFlowIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "132",
    height: "112",
    viewBox: "0 0 132 112",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#create-new-flow-a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M107.688 10H14C6.268 10 0 16.268 0 24v73.677c0 7.732 6.268 14 14 14h93.688c7.731 0 14-6.268 14-14V24c0-7.732-6.269-14-14-14Z",
    fill: "#3894FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.688 0H20c-5.523 0-10 4.477-10 10v81.677c0 5.523 4.477 10 10 10h101.688c5.522 0 10-4.477 10-10V10c0-5.523-4.478-10-10-10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.688 1H21c-5.523 0-10 4.477-10 10v79.677c0 5.523 4.477 10 10 10h99.688c5.522 0 10-4.477 10-10V11c0-5.523-4.478-10-10-10Z",
    stroke: "#171717",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.141 10H11v2.065h120.141V10ZM19.547 8.097A1.548 1.548 0 1019.545 5a1.548 1.548 0 00.002 3.096Zm5 0A1.548 1.548 0 1024.545 5a1.548 1.548 0 00.002 3.096Zm5 0A1.548 1.548 0 1029.545 5a1.548 1.548 0 00.002 3.096Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.219 16H18v76.387h106.219V16Z",
    fill: "#E1F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.344 30H34a2 2 0 00-2 2v10.452a2 2 0 002 2h73.344a2 2 0 002-2V32a2 2 0 00-2-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.844 29.5H33.5a2 2 0 00-2 2v11.452a2 2 0 002 2h74.344a2 2 0 002-2V31.5a2 2 0 00-2-2Z",
    stroke: "#171717",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.344 55H34a2 2 0 00-2 2v10.452a2 2 0 002 2h73.344a2 2 0 002-2V57a2 2 0 00-2-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.844 54.5H33.5a2 2 0 00-2 2v11.452a2 2 0 002 2h74.344a2 2 0 002-2V56.5a2 2 0 00-2-2Z",
    stroke: "#171717",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m105.559 69.5 1.853-1.853L100 65l2.647 7.412 1.853-1.853L107.941 74 109 72.941l-3.441-3.441Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "create-new-flow-a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "132",
    height: "112",
    fill: "#fff"
  }))));
}, {});